class PriceHandler {
  static formatPrice(price, isWholesale = false) {
    // If price is a string (e.g. "1299.00"), convert to number
    if (typeof price === 'string') {
      return parseInt(price.replace(/[^0-9]/g, ''));
    }
    
    // If it's already a number, return as is
    return parseInt(price);
  }

  static calculateCartTotal(items, isWholesale = false) {
    return items.reduce((total, item) => {
      const itemPrice = this.formatPrice(item.price, isWholesale);
      return total + (itemPrice * item.quantity);
    }, 0);
  }
} 